import { SectionCards } from "@/components/section-cards";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import Orders from "@/orders/orders";
import { AllBranchesComparison } from "@/components/charts/all-branches-comparison";
import { ScoreByArticle } from "@/components/charts/score-by-article";
import { TrendQualityScore } from "@/components/charts/trend-quality-score";
import { BranchQualityScoring } from "@/components/branch-quality-scoring";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DashboardControls } from "@/components/dashboard-controls";
import { BranchScoreMap } from "@/components/branch-score-map";
import { useLocalization } from "@/context/localization-context";

export default function AdminDashboard() {
  const { t } = useLocalization();

  return (
    <div className="flex flex-1 flex-col overflow-auto">
      <div className="@container/main flex flex-1 flex-col gap-2">
        <Tabs defaultValue="overview" className="flex flex-1 flex-col">
          <div className="flex flex-col gap-3 px-4 pt-4 lg:px-6 md:flex-row md:items-center md:justify-between md:pt-6">
            <TabsList>
              <TabsTrigger value="overview">
                {t("dashboard.overview")}
              </TabsTrigger>
              <TabsTrigger value="scoring">
                {t("dashboard.scoring")}
              </TabsTrigger>
            </TabsList>
            <DashboardControls />
          </div>

          <TabsContent value="overview" className="mt-0">
            <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
              <SectionCards />

              <div className="grid grid-cols-1 gap-4 px-4 lg:px-6 xl:grid-cols-2">
                <ScoreByArticle />
                <TrendQualityScore />
              </div>

              <div className="px-4 lg:px-6">
                <h2 className="mb-4 text-2xl font-semibold tracking-tight">
                  {t("dashboard.branchComparisonHeading")}
                </h2>

                <div className="mb-6 grid grid-cols-1 gap-4 xl:grid-cols-[minmax(0,1.35fr)_minmax(360px,0.65fr)]">
                  <AllBranchesComparison />
                  <BranchScoreMap className="h-full" />
                </div>
              </div>

              <div className="app-layout gap-4 px-4 lg:px-6">
                <Card>
                  <CardHeader>
                    <CardTitle>{t("dashboard.orders")}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <Orders
                      getLink={(path) => `/orders/${path}`}
                      useDashboardDateRange={true}
                    />
                  </CardContent>
                </Card>
              </div>
            </div>
          </TabsContent>

          <TabsContent value="scoring" className="mt-0">
            <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
              <div className="px-4 lg:px-6">
                <BranchQualityScoring />
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
